export const filesize = (bytes: number, precision: number = 1): string => {
  if (isNaN(parseFloat(bytes.toString())) || !isFinite(bytes)) return '-'

  const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB']
  const size = Math.floor(Math.log(bytes) / Math.log(1024))
  return (
    (bytes / Math.pow(1024, Math.floor(size))).toFixed(precision) +
    ' ' +
    units[size]
  )
}
